<script lang="ts">
	// Design system components
	import { Select } from '@Shelly/shelly-design-system';
	// Config
	import { getTRVSchemeChartConfig } from './chart_config';
	import { getDailyRangeOptions, startsWeekOnSun } from 'src/helpers/date_helper';
	// Components
	import Chart from './Chart.svelte';
	//Types
	import type { ChartDataInterface } from '../../types/Chart';
	import type { IChartTempSchedule } from '../../types/TemperatureSchemeType';
	import { format } from 'svelte-i18n';

	export let data: IChartTempSchedule;

	const startWeekOnSun = startsWeekOnSun(),
		rangeOptions = getDailyRangeOptions(startWeekOnSun),
		onChangeRange = (range: number) => {
			rangeValue = rangeOptions.find((el) => el.value === range);
			chartData = getTRVSchemeChartConfig(range, data, startWeekOnSun);
		},
		selectChangeRange = (e: CustomEvent | { detail: number }) => {
			onChangeRange(e.detail.value);
		},
		chartChangeRange = (e: CustomEvent) => {
			if (e.detail.action == 'dblClick' && rangeValue.value == -1) {
				const day = new Date(e.detail.date).getDay();
				onChangeRange(day);
			}
		};

	let rangeValue = rangeOptions[0],
		chartData: ChartDataInterface;

	$: chartData = getTRVSchemeChartConfig(rangeValue.value, data, startWeekOnSun);
</script>

<div class="d-flex">
	<Select
		id="select-schedules-chart-range"
		aria-label={$format('select_schedules_chart_range', {
			default: 'Select schedules chart range',
		})}
		value={rangeValue}
		size="m"
		icon="fas fa-clock-rotate-left"
		options={rangeOptions}
		on:change={selectChangeRange}
	/>
</div>
<Chart {chartData} on:change={chartChangeRange} />
